import type { SFC } from 'react';

import { fossaMonospaceFont } from '../../../theme/typography';

import Pill from './Pill';

/**
 * Pill for project/org labels
 */
const LabelPill: SFC<{
  label: string;
}> = ({
  label,
}) => {
  return (
    // by only doing marginRight, we ensure left alignment is the same as the parent component and label pills are
    // organized left to right
    <Pill color="label-pill label label-rounded-squared gray" style={{ marginRight: 5, marginBottom: 5, fontFamily: fossaMonospaceFont, fontWeight: 400 }}>
      <span>
        {label}
      </span>
    </Pill>
  );
};

export default LabelPill;
